<template>
  <div
    slot="result"
    v-if="profile.name"
    class="Overview row"
  >
    <div class="col-md-4">
      <Panel>
        <template slot="header">
          <h2>Overview</h2>
        </template>

        <template slot="body">
          <Basic
            :profile="profile"
          ></Basic>
        </template>
      </Panel>
    </div>

    <div class="col-md-8">
      <Panel>
        <template slot="header">
          <h2>Rating History</h2>
        </template>

        <template slot="body">
          <Loader
            :url="getPerformanceUrl"
            v-model="performance"
            class="h100"
          >
            <LineChart
              slot="result"

              :labels="{
                x: 'Date',
                y: 'Rating' ,
                uX: '',
                uY: ''
              }"

              :timescale="true"

              :series="getPerformanceLineChart"
            >
            </LineChart>
          </Loader>
        </template>
      </Panel>
    </div>

    <div class="col-md-6">
      <Panel>
        <template slot="header">
          <h2>Results</h2>
        </template>

        <template slot="body">
          <BarChart
            :data="getResultsBarChart"

            :series="{
              value: {}
            }"

            :margin="{
              top:    20,
              right:  60,
              bottom: 30,
              left:   60
            }"

            :sort="false"
          ></BarChart>
        </template>
      </Panel>
    </div>

    <div class="col-md-6">
      <Panel>
        <template slot="header">
          <h2>Colours</h2>
        </template>

        <template slot="body">
          <PieChart
            :data="getColoursPieChart"
          ></PieChart>
        </template>
      </Panel>
    </div>
  </div>
</template>

<script>
  import Panel from '@/legacy/components/widgets/Panel';
  import Icon from '@/legacy/components/widgets/Icon';
  import Loader from '@/legacy/components/widgets/Loader';
  import LineChart from '@/legacy/components/widgets/LineChart';
  import BarChart from '@/legacy/components/widgets/BarChart';
  import PieChart from '@/legacy/components/widgets/PieChart';
  import Profile from '@/legacy/lib//model/Profile';
  import Basic from '@/legacy/views/player/Basic';
  import { lang } from '@/legacy/lib//lang';
  import { httpBuildQuery, maxKey, minKey, ordinal, urlencode } from '@/legacy/lib//util';
  import { capitalize, codeToColour } from '@/legacy/lib//template';

  export default {
    props: {
      profile: {
        type: Profile
      },
    },

    data () {
      return {
        performance: []
      }
    },

    components: {
      Icon,
      Loader,
      Panel,
      LineChart,
      BarChart,
      PieChart,
      Basic
    },

    methods: {
      ordinal,
      Profile
    },

    computed: {
      getPerformanceUrl () {
        return `/profiles/${urlencode (this.profile.name)}/${this.profile.id}/performance`;
      },

      getPerformanceLineChart ()
      {
        let series = [
          {
            label: 'Rating',
            colour: 'red',
            points: []
          }
        ];

        for (let point of this.performance) {
          series
            [0]
            .points
            .push ({
              x: point.timestamp,
              y: point.rating
            });
        }

        return series;
      },

      getResultsBarChart () {
        let points = {};

        // let min = minKey (this.profile.results);
        let min = 1;
        let max = maxKey (this.profile.results);

        for (let i = max; i >= min; i--) {
          let y = 0;

          if (i in this.profile.results) {
            y = this.profile.results [i];
          }

          points [ordinal (i)] = { value: y };
        }

        return points;
      },

      getColoursPieChart () {
        let slices = [];

        for (let colour in this.profile.colours) {
          slices.push ({
            label: capitalize (lang (`colour.${colour}`)),
            colour: lang (`colour.${colour}`),
            value: this.profile.colours [colour]
          });
        }

        return slices;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .Overview {
    .Panel {
      height: calc(100% - 30px);
    }
  }
</style>